export const routes = (prefix) => [
    {
        path: `/${prefix}/configs`,
        name: `${prefix}.configs.index`,
        component: () => import('./index.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.configs.index`,
                PageDescription: "Admin: User Configs",
            },
        }
    },
];
